module.exports = __webpack_public_path__ + "static/media/Icons_add-circle.fd2151ff.svg";